import { toast } from 'react-toastify';

export const alertService = {
  success: (message: string) =>
    toast.success(message, { toastId: `success-${Date.now()}` }),

  error: (message: string) =>
    toast.error(message, { toastId: `error-${Date.now()}` }),

  warning: (message: string) =>
    toast.warning(message, { toastId: `warning-${Date.now()}` }),

  info: (message: string) =>
    toast.info(message, { toastId: `info-${Date.now()}` }),

  question: (
    title: string,
    message: string,
    buttons: { text: string; action?: () => void }[]
  ) => {
    toast.info(
      <div>
        <strong>{title}</strong>
        <p>{message}</p>
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          {buttons.map((btn, i) => (
            <button
              key={i}
              onClick={() => {
                btn.action?.();
                toast.dismiss();
              }}
              style={{
                padding: '4px 10px',
                cursor: 'pointer',
                background: '#3438c7',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
              }}
            >
              {btn.text}
            </button>
          ))}
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        toastId: `question-${Date.now()}`,
      }
    );
  },

  confirmation: (
    title: string,
    message: string,
    onConfirm: () => void,
    onCancel: () => void
  ) => {
    toast.warn(
      <div>
        <strong>{title}</strong>
        <p>{message}</p>
        <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
          <button
            onClick={() => {
              onConfirm();
              toast.dismiss();
            }}
            style={{
              padding: '4px 10px',
              cursor: 'pointer',
              background: '#3438c7',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
            }}
          >
            Confirm
          </button>
          <button
            onClick={() => {
              onCancel();
              toast.dismiss();
            }}
            style={{
              padding: '4px 10px',
              cursor: 'pointer',
              background: '#aaa',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
            }}
          >
            Cancel
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        toastId: `confirmation-${Date.now()}`,
      }
    );
  },

  warn: (message: string) =>
    toast.warning(message, { toastId: `warn-${Date.now()}` }),
};
